import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SpeakersModuleIcon = (props) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Speakers" transform="translate(2013 8886)">
        <rect id="Rectangle_3211" data-name="Rectangle 3211" width="24" height="24" transform="translate(-2013 -8886)" fill="none" />
        <g id="Mic" transform="matrix(0.995, -0.105, 0.105, 0.995, -2013.266, -8883.68)">
          <path id="Path_11016" data-name="Path 11016" d="M14.39,3.32a4.751,4.751,0,1,1,2.316,8.706l-4.173-6.34A4.738,4.738,0,0,1,14.39,3.32Z" transform="translate(0 0)" />
          <path id="Path_11017" data-name="Path 11017" d="M11.174,6.933l3.853,5.854L1.869,19.215,0,16.425Z" transform="translate(0 0)" />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default SpeakersModuleIcon;
